'use strict';

import angular from 'angular';
import currencySelectComponentModule from '../currency_select';
import currencyInputDirectivetModule from '../../directives/currency_input.directive';
import mobileNavigationMenuServiceModule from '../../services/mobile_navigation_menu.service';
import currencyModelModule from '../../models/currency_model.service';
import navigationComponent from './navigation.component';

const dependencies = [
  currencySelectComponentModule,
  currencyInputDirectivetModule,
  mobileNavigationMenuServiceModule,
  currencyModelModule
];

export default angular
  .module('common.navigation', dependencies)
  .component('saNavigation', navigationComponent)
  .name;



// WEBPACK FOOTER //
// ./app/src/common/navigation/index.js